<template>
<div>
    <Breadcrumbs main="Admin" submain="Course" title="Category" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Category</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="category_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="max-width: 200px;">
                                            <h7>{{ row.item.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(parent)="row">
                                        <div v-if="row.item.parent == null || row.item.parent == 0" @click="createNewSubCategory(row.item.id)">
                                            <h7
                                                v-b-modal.modal-center-sub-category
                                                style="
                                                    text-decoration: underline;
                                                    background: #f0f4fa;
                                                    color: #568ae3;
                                                    border-radius: 999px;
                                                    padding: 4px 16px;
                                                    cursor: pointer;
                                                    display: inline-block;
                                                    font-weight: 500;
                                                    font-size: 14px;
                                                "
                                            >
                                                Add Sub Category
                                            </h7>
                                        </div>
                                        <div v-else>
                                            <h7
                                                style="
                                                    background: #fff5eb;
                                                    color: #fa9d40;
                                                    border-radius: 999px;
                                                    padding: 4px 16px;
                                                    display: inline-block;
                                                    font-weight: 500;
                                                    font-size: 14px;
                                                "
                                            >{{ row.item.parent?.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(banner)="row">
                                        <div v-if="row.item.banner" style="min-width: 120px;">
                                            <img style="max-height: 80px;" :src="host + row.item.banner" alt="">
                                        </div>
                                    </template>

                                    <!-- <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(expiry_date)="row">
                                        <div v-if="row.item.expiry_date" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.expiry_date.split('T')[0] }}</h7>
                                            <h7>{{ row.item.expiry_date.split('T')[1].replace('Z', '') }}</h7>
                                        </div>
                                    </template> -->

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCategory(data.item.slug)" title="Delete"></feather>
                                            </div>
                                            <div @click="editCategory(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Category Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Course Category" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter course category" v-model="category.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Banner Image</label>
                        <input type="file" accept="image/*" @change="onImageChange($event, 'banner')" />
                    </div>
                    <div v-if="bannerPreview" style="margin-top: 20px;">
                        <img :src="bannerPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Category Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Course Category" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter course title" v-model="edit_category.title">
                    </div>
                </div>
            </div> 
            <div class="row" v-if="edit_category.parent != 0">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Parent</label>
                        <select class="form-control digits" v-model="edit_category.parent">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Banner Image</label>
                        <input type="file" accept="image/*" @change="onImageChangeEdit($event, 'banner')" />
                    </div>
                    <div v-if="bannerPreview" style="margin-top: 20px;">
                        <img :src="bannerPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Sub Category Create Modal -->
    <b-modal id="modal-center-sub-category" ref="modal" title="Add Sub Category" size="md" @show="resetSubModal" @hidden="resetSubModal" @ok="handleSubOk">
        <form ref="form" @submit.stop.prevent="handleSubSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter sub category" v-model="sub.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Banner Image</label>
                        <input type="file" accept="image/*" @change="onSubImageChange($event, 'banner')" />
                    </div>
                    <div v-if="bannerPreview" style="margin-top: 20px;">
                        <img :src="bannerPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Course Category Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this category?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'parent',
                    label: 'Parent',
                    sortable: true
                },
                {
                    key: 'banner',
                    label: 'Banner',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            category: {
                title: "",
                parent: 0,
                banner: null
            },
            edit_category: {
                slug: null,
                title: "",
                parent: 0,
                banner: null
            },
            sub: {
                title: "",
                parent: null,
                banner: null
            },
            delete_value: null,
            bannerPreview: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            category_list: state => state.course.category,
            loading: state => state.course.categoryLoading,
            error: state => state.course.categoryError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("course/fetchCategory").then(() => {
            this.items = this.category_list
            this.totalRows = this.category_list.length;
        });
    },

    methods: {
        onImageChange(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'banner') {
                    this.category.banner = e.target.result;
                    this.bannerPreview = e.target.result;
                } 
            };
        },

        onSubImageChange(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'banner') {
                    this.sub.banner = e.target.result;
                    this.bannerPreview = e.target.result;
                } 
            };
        },

        onImageChangeEdit(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'banner') {
                    this.edit_category.banner = e.target.result;
                    this.bannerPreview = e.target.result;
                } 
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.category.title = ""
            this.category.parent = 0
            this.category.banner = null
            this.bannerPreview = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("course/addCategory", this.category).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                   this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        resetSubModal() {
            this.sub.title = ""
            this.sub.parent = null
            this.sub.banner = null
            this.bannerPreview = null
        },

        handleSubOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubSubmit()
        },

        createNewSubCategory(id) {
            this.sub.parent = id
        },

        handleSubSubmit() {
            this.$store.dispatch("course/addCategory", this.sub).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetSubModal();
                    this.$bvModal.hide('modal-center-sub-category');
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCategory(detail) {
            this.edit_category.slug = detail.slug ? detail.slug : null
            this.edit_category.title = detail.title ? detail.title : null
            this.edit_category.parent = detail.parent ? detail.parent.id : 0
            this.bannerPreview = detail.banner ? this.host + detail.banner : null
        },

        resetEditModal() {
            this.edit_category.slug = null
            this.edit_category.title = null
            this.edit_category.parent = 0
            this.edit_category.banner = null
            this.bannerPreview = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("course/updateCategory", {
                id: this.edit_category.slug,
                category: this.edit_category
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCategory(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("course/deleteCategory", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
